import { Skeleton } from 'src/components/atoms';

export const mapContainerStyles = {
  height: '50vw',
  width: '50vw',
  maxHeight: '30rem',
  maxWidth: '30rem'
};
export const MapSkeleton = () => {
  return (
    <Skeleton sx={{ marginX: 'auto' }} data-testid='google maps skeleton'>
      <div style={mapContainerStyles} />
    </Skeleton>
  );
};
